export enum TestingStatus {
    InProgress = 0,
    Complete = 1,
    Abandoned = 2,
}

// const asDropdownOptions = (other: TestingStatus) => {
//     return Object.keys(TestingStatus).map(item => (
//         {
//             text: TestingStatus[item],
//             id: item,
//             disabled: item === other,
//         }
//     ));
// }